import { render, staticRenderFns } from "./dialogHandleTask.vue?vue&type=template&id=06535d50"
import script from "./dialogHandleTask.vue?vue&type=script&lang=js"
export * from "./dialogHandleTask.vue?vue&type=script&lang=js"
import style0 from "./dialogHandleTask.vue?vue&type=style&index=0&id=06535d50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports